let _toastrRef;

export const hookToastr = (toastrRef) => {
    _toastrRef = toastrRef;
}

export const error = (error) => {
    _toastrRef.error(error);
}

export const success = (message) => {
    _toastrRef.success(message);
}



// WEBPACK FOOTER //
// ./src/fw/globals/Notifications.js